import MetricBar from "@/lib/molecules/metric-bar";
import { ValueFormatterParams } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";

export function dateFormatter(params: ValueFormatterParams) {
    if (params.value) {
        return new Date(params.value).toLocaleDateString("en-GB");
    } else {
        return "";
    }
}

export function paramsEuroFormatter(params: ValueFormatterParams | CustomCellRendererProps) {
    if (params.value) {
        return Math.round(parseFloat(params.value)) + " €";
    } else {
        return "-";
    }
}

export function euroFormatter(val: string) {
    if (val) {
        return parseFloat(val).toFixed(0) + " €";
    } else {
        return "-";
    }
}

export function euroFormatterTwoDecimals(val: string) {
    if (val) {
        return parseFloat(val).toFixed(2) + " €";
    } else {
        return "-";
    }
}

export function percentageFormatterMultipliedByHundred(params: ValueFormatterParams) {
    if (params.value) {
        return (parseFloat(params.value) * 100).toFixed(0) + "%";
    } else {
        return "-";
    }
}
export const occupancyBarRenderer = (params: CustomCellRendererProps) => {
    return <MetricBar value={params.value} max={100} decimals={0} suffix="%" />;
};

export const ratingBarRenderer = (params: CustomCellRendererProps, decimals = 1) => {
    return (
        <MetricBar
            value={params.value}
            min={0}
            max={5}
            decimals={decimals}
            thresholds={{
                excellent: 4.8, // 4.8+ = emerald (dark green)
                good: 4.5, // 4.6-4.79 = light green
                fair: 4.0, // 4.3-4.59 = yellow
                // < 4.3 = red
            }}
        />
    );
};

export const redOrGreenText = {
    "text-danger fw-bolder": negativeValue,
    "text-success fw-bolder": positiveValue,
};

function negativeValue(params: ValueFormatterParams) {
    return params.value < 0;
}

function positiveValue(params: ValueFormatterParams) {
    return params.value >= 0;
}

export function overViewIncomeFormatter(number: number): string {
    return Math.round(number).toLocaleString("de-DE") + " €";
}

export function overViewBarChartIncomeFormatter(number: number): string {
    if (number > 1000) {
        return (number / 1000).toFixed(1) + "k";
    }
    return Math.round(number).toLocaleString("de-DE") + " €";
}

export function overViewBarChartAdrFormatter(number: number): string {
    let fixedNumber = parseFloat(number.toFixed(1));
    return fixedNumber.toLocaleString("de-DE") + " €";
}

export function overViewAdrFormatter(number: number) {
    let fixedNumber = parseFloat(number.toFixed(1));
    return fixedNumber.toLocaleString("de-DE") + " €";
}

export function reportGraphsIncomeFormatter(number: number | undefined) {
    if (!number) {
        return "0 €";
    }
    return Math.round(number).toLocaleString("de-DE") + "€";
}

export function reportGraphsAdrFormatter(number: number | undefined) {
    if (!number) {
        return "0";
    }
    return Math.round(number).toLocaleString("de-DE") + "€";
}

export function reportGraphsOccupancyFormatter(number: number | undefined) {
    if (!number) {
        return "0%";
    }
    return Math.round(number).toLocaleString("de-DE") + "%";
}

export function reportBarChartNumberFormatter(number: number) {
    return Math.round(number).toString();
}
